import SkeletonLoader from './SkeletonLoader.vue';

export default (app) => {
    app.component('SkeletonLoader', SkeletonLoader);
};
